function debounce(func, delay) {
  let inDebounce;
  return function() {
    const context = this;
    const args = arguments;
    clearTimeout(inDebounce);
    inDebounce = setTimeout(() => func.apply(context, args), delay);
  };
}

export function toggleMenu(header) {
  header.classList.toggle('!block');
}

export function toggleLink(link) {
  link.classList.toggle('is--opened');
}

export function closeMenu(event, header, submenuToggle) {
  var target = event.target;
  if (!target.closest('#header')) {
    header.classList.remove('menu-visible');
    if (submenuToggle) submenuToggle.classList.remove('submenu-abierto');
  }
}

export const debouncedCloseMenu = debounce(closeMenu, 300);
